export default "__VITE_ASSET__85364199__"